import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
class GdsStateServiceModule {
  static {
    this.ɵfac = function GdsStateServiceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsStateServiceModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsStateServiceModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsStateServiceModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsStateService {
  constructor() {
    this.componentsToLoad$ = new BehaviorSubject(0);
    this.componentsLoaded$ = new BehaviorSubject(0);
    this.componentsLoaded = 0;
  }
  resetComponentsToLoad() {
    this.componentsToLoad$.next(0);
  }
  setGdsCpsToLoad(toLoad) {
    this.componentsToLoad$.next(toLoad);
  }
  resetComponentsLoaded() {
    this.componentsLoaded = 0;
    this.componentsLoaded$.next(0);
  }
  incrementComponentsLoaded() {
    this.componentsLoaded += 1;
    this.componentsLoaded$.next(this.componentsLoaded);
  }
  static {
    this.ɵfac = function GdsStateService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsStateService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsStateService,
      factory: GdsStateService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsStateService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-state-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsStateService, GdsStateServiceModule };
